const INITIAL_STATE = {
    tarifarios: [],
    tarifario: null,
    categorias: [],
    detalhesTarifario: null
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'DIARIAS_FETCH':
            return { ...state, tarifarios: action.payload }
        case 'TARIFARIOS_FETCH':
            return { ...state, tarifarios: action.payload }
        case 'TARIFARIO_FETCH':
            return { ...state, tarifario: action.payload }
        case 'TARIFARIO_DETALHES_FETCH':
            return { ...state, detalhesTarifario: action.payload }
        case 'CATEGORIAS_FETCH':
            return { ...state, categorias: action.payload }
        default:
            return state
    }
}